import lockedRoundedIcon from '../../../../../assets/images/lock-rounded.svg';

export const WithdrawLocked = () => (
  <div>
    <img src={lockedRoundedIcon} alt="locked" className="h-[8rem]" loading="eager" />
    <h1 className="text-[24px] leading-[24px] tracking-[2%] text-black-strong mt-[26px]">Withdrawal currently unavailable</h1>
  </div>
);
